export const BRAND_HOME_ROUTE = '/how-it-works';
